const meansOfAccess = [
  {
    id: 0,
    name: "App",
  },
  {
    id: 1,
    name: "Access Card Delivered",
  },
]

export default meansOfAccess
